import React from "react";
import UseContext from "hooks/useContext";

const PerimeterMemberLabel = ({ member }) => {
    const { language } = UseContext();
    const roleLabel = language.getValue(`perimeters.roles.${member.role}`);

    return (
        <span className="flex min-w-0 flex-col gap-0.5">
            <span className="truncate text-sm text-gray-900">
                {member.firstname}{" "}
                <span className="uppercase">{member.lastname}</span>
            </span>
            {roleLabel && (
                <span className="truncate text-sm text-gray-500">
                    {roleLabel}
                </span>
            )}
        </span>
    );
};

export default PerimeterMemberLabel;
